// extracted by mini-css-extract-plugin
export default {"img":"Products_img__yGQbu","subHeading":"Products_subHeading__J6AuY","gridItemTwo":"Products_gridItemTwo__UXxlA","whiteText":"Products_whiteText__1h-QD"};